"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Rain;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactUseinterval = _interopRequireDefault(require("react-useinterval"));

var _gatsbyPluginUtils = require("@pittica/gatsby-plugin-utils");

var _rain = require("../helpers/rain");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function Rain({
  color,
  stroke,
  parts,
  timing
}) {
  const ref = (0, _react.useRef)();
  const [particles, setParticles] = (0, _react.useState)([]);

  const init = () => {
    if (typeof window !== "undefined") {
      const canvas = ref.current;
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;

      if (canvas.getContext) {
        const {
          r,
          g,
          b
        } = (0, _gatsbyPluginUtils.hexToRgb)(color);
        const context = canvas.getContext("2d");
        context.fillStyle = `rgba(${r}, ${g}, ${b}, 0.5)`;
        context.width = stroke;
        context.lineCap = "round";
        setParticles((0, _rain.create)(parts, canvas.width, canvas.height));
      }
    }
  };

  (0, _react.useEffect)(() => {
    init();
    window.addEventListener("resize", init);
    return () => window.removeEventListener("resize", init);
  }, [particles.length > 0]);
  (0, _reactUseinterval.default)(() => {
    const canvas = ref.current;

    if (canvas.getContext) {
      const context = canvas.getContext("2d");
      (0, _rain.draw)(particles, context, canvas.width, canvas.height);
    }
  }, timing);
  return /*#__PURE__*/_react.default.createElement("canvas", {
    ref: ref
  });
}

Rain.propTypes = {
  stroke: _propTypes.default.number,
  parts: _propTypes.default.number,
  color: _propTypes.default.string,
  timing: _propTypes.default.number
};
Rain.defaultProps = {
  stroke: 2,
  parts: 1000,
  color: "#ffffff",
  timing: 30
};